import styled from 'styled-components';

export const Wrapper = styled.div`
  border-radius: 4px;
  background-color: white;
  cursor: default;
  width: ${props => (props.theme.isMobile ? '100%' : '303px')};
  position: relative;
  margin: ${props => (props.theme.isMobile ? '8px 0 0' : '8px 16px 0')};
  align-items: baseline;
`;
